<script>
  import { navigate } from "svelte-routing";
  import { onMount } from "svelte";    
  import {guiText} from "../../tstore/guiText";
  import {momentumCxData} from "../../tstore/momentumCxData";
  import {myAuthObject} from "../../tstore/myauth";
  import {checkForRoleAdmin, checkForRoleAudience} from '../../lib/checkAuthObject.js'; 
  import {tenantsGet} from "../../api/TenantsGet";
  import {surveysGet} from "../../api/SurveysGet";  
  import DashHeader from "components/Dashboards/DashHeader.svelte";
  import MomentumBPButton from "components/Dashboards/MomentumBPButton.svelte";
  import MomentumBPModal from "components/Dashboards/MomentumBPModal.svelte";

  export let my_lang;
  export let color = "light";

  let showModal = false;
  let bLink;

  // let button_popup_class = "bg-red-400 text-white float-right active:bg-red-500 font-bold uppercase text-xs px-4 py-2 rounded shadow "; 
  let defTxtCol = 'bg-red-800 text-white';
  if (color === 'light'){ defTxtCol= 'bg-white'; }

  const flex_starter = "relative content-top items-top justify-top w-full heightdefs ";
  const flex_ender = "mr-auto text-center break-words shadow-lg rounded " + defTxtCol;
  let defClassItem = flex_starter + "lg:w-12/12 mb-2 " + flex_ender;

  let buttonBase = "text-emerald-500 background-transparent font-bold capitalize px-4 ";
  buttonBase += "hover:text-emerald-600 text-xs outline-none focus:outline-none ";
  buttonBase += "mr-1 mb-1 mt-1 ease-linear transition-all duration-150 "; 

  let tenantsLabel = '';
  let surveysLabel = ''; 
  let tenantsAry = []; 
  let surveys_by_tenant = {};

  const roleAdminStatus = checkForRoleAdmin($myAuthObject);
  const roleAudienceStatus = checkForRoleAudience($myAuthObject);
  
  const toggleModalWindow = (e) => {     
    showModal = !showModal;
    bLink = `https://easy-feedback.com/${e}`;
  };

  onMount(async () => { 
    if ( roleAdminStatus === false && roleAudienceStatus === false ) { navigate('/auth/login', { replace: true }); };

    let tenantsRawResp = await tenantsGet({'authO': $myAuthObject, 'guiTxt': $guiText });
    tenantsAry = await tenantsRawResp.data; 
    let surveysRawResp = await surveysGet({'authO': $myAuthObject, 'guiTxt': $guiText });
    surveys_by_tenant = await surveysRawResp.by_tenant;

    tenantsLabel = tenantsAry[0].label;
    surveysLabel = surveys_by_tenant[tenantsAry[0].uuid][0]['label'];    

    let eleT = document.getElementById('admin_navbar_tenant');
    eleT.innerHTML = '';
    eleT.insertAdjacentHTML('beforeend', '<i class="fas fa-industry mr-2 text-sm text-blueGray-400"></i>');
    eleT.insertAdjacentText('beforeend', tenantsLabel);
    
    let eleP = document.getElementById('admin_navbar_project');
    eleP.innerHTML = '';
    eleP.insertAdjacentHTML('beforeend', '<i class="fas fa-square-poll-horizontal mr-2 text-sm text-blueGray-400"></i>');
    eleP.insertAdjacentText('beforeend', surveysLabel);      

  });

</script>

{#if showModal}  
  <MomentumBPModal 
      color={color}  
      toggleModalWindow={toggleModalWindow}  
      header_text={$guiText.general.momentum_surveys[my_lang]}
      bLink={bLink}
  />
{/if}

{#if $myAuthObject.whoami.valid === true }

<momentum_main>
  <div id="prosper_momentum_header">
    <DashHeader 
      color="ffffff" 
      background_color="076623" 
      headline={$guiText.general.momentum_surveys_cx[my_lang]} show_logo="show" />
  </div>

  <div id="prosper_momentum_subheader">
    <DashHeader 
      color="ffffff" 
      background_color="A6CD8A" 
      headline={$guiText.general.icp_information_and_communication_providers[my_lang]} />
  </div>

  {#each $momentumCxData.cx as item}

    <div id="prosper_momentum_txt_{item.pos}">
      <div class="heightdefs">
        <div class="{defClassItem}">           
          {#if roleAdminStatus === true} 

          <div id="prosper_momentum_box_main" class="heightdefs">

            <div id="prosper_momentum_box_a">
              <div class=" text-black text-sm font-bold pt-2 mt-2 pb-2 mb-2">              
                  {item.lbl} 
              </div>
            </div>

            <div id="prosper_momentum_box_b">
              <div class="align-text-black text-sm"> 
                {item.exp}
              </div>
            </div>

            <div id="prosper_momentum_box_c" class="pb-2 mb-2">
              <MomentumBPButton 
                  bText={$guiText.general.go_to_the_survey[my_lang]}   
                  bind:showModal={showModal} 
                  bind:bLink={item.lnk} 
                  toggleModalWindow={toggleModalWindow}                  
                  />
            </div>

          </div>

          {/if}          
        </div>
      </div>
    </div>
  {/each}

</momentum_main>

{/if}
